/* eslint complexity: "off" */
import React from 'react'
import styled from 'styled-components'
import { withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import formatNumber from './helpers/formatNumber'
import processInput from './helpers/processInput'

const minusOnes = {
  onetime_reduction: true,
  business_c_corp_taxes: true,
  debt_already_counted: true,
  zero_balance_tradelines: true
}
const Span = styled.span`
  display: inline;
  flex-direction: row;
  justify-self: end;
  position: relative;
  height: 30px;
  ${props => props.bold ? 'font-weight: 600;' : ''}
  ${props => props.italic ? 'font-style: italic;' : ''}
  display: flex;
  justify-content: flex-end;
  align-items: center;
`
const Input = styled.input`
  border-radius: 4px;
  margin-bottom: 0px !important;
  width: 75%;
  justify-self: end;
  align-self: start;
  -moz-appearance: textfield;
  text-align: right;
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: none;
  }
`
const Exclamation = styled.i`
  color: #dd6a01;
  position: absolute;
  left: -16px;
  align-self: center;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`
class Cell extends React.Component {
  constructor(props) {
    super()
    this.state = {
      data: props.data,
      error: false
    }
  }
  componentWillReceiveProps(nextProps) {
    const { data } = nextProps
    this.setState({
      data
    })
    if (this.props.yearPeriod !== nextProps.yearPeriod && this.input) {
      this.input.value = ''
      this.setState({ data: '' })
    }
  }
  onBlur = () => {
    const {
      data,
      markForDelete,
      year,
      category,
      saveFromDelete,
      inlineEdit,
      markForSave,
      yearPeriod,
      originalReason,
      yearSource
    } = this.props
    this.setState({ error: false })
    let newData = null
    if (this.input.value !== '') {
      newData = processInput(this.input.value)
      if (newData === null  || newData < 0 && category !== 'other_business_cashflow') {
        this.setState({ error: true })
        return
      }
    }
    this.input.value = newData
    if (data !== newData && !Number.isNaN(newData) && typeof newData === 'number') {
      this.setState({
        data: newData
      })
      if (markForSave && !inlineEdit) {
        const datum = {
          period: yearPeriod,
          year,
          category,
          data: processInput(this.input.value),
          reason: originalReason || null,
          source: yearSource // default source is manual_document
        }
        markForSave(year, category, datum)
      }
      if (saveFromDelete) {
        saveFromDelete(year, category)
      }
    } else if (data !== null && this.input.value === '' && !inlineEdit) {
      if (markForDelete) {
        markForDelete(year, category)
      }
    }
  }
  onKeyDown = e => {
    this.setState({ error: false })
    const { moveFns } = this.props
    const { keyCode, shiftKey, ctrlKey, metaKey } = e
    // Only numbers, spaces, tab, enter, copy, paste, plus, and minus are allowed
    const allowed = {
      8: true,
      9: true,
      13: true,
      37: true,
      38: true,
      39: true,
      40: true,
      46: true,
      48: true,
      49: true,
      50: true,
      51: true,
      52: true,
      53: true,
      54: true,
      55: true,
      56: true,
      57: true,
      67: true,
      86: true,
      96:  true,
      97:  true,
      98:  true,
      99:  true,
      100: true,
      101: true,
      102: true,
      103: true,
      104: true,
      105: true,
      187: true,
      189: true
    }
    if (e.keyCode === 187 && !shiftKey) {
      e.preventDefault()
    } else  if (e.keyCode === 189 && shiftKey) {
      e.preventDefault()
    } else if (!(keyCode in allowed)) {
      e.preventDefault()
      return false
    } else if (keyCode === 13 && shiftKey) {
      if (moveFns) {
        e.preventDefault() // Cell may not always be used in edit mode, if it is not, don't call move functions
        moveFns.up()
      }
    } else if (keyCode === 13) {
      if (moveFns) {
        e.preventDefault()
        moveFns.down()
      }
    } else if (keyCode === 9 && shiftKey) {
      if (moveFns) {
        e.preventDefault()
        moveFns.left()
      }
    } else if (keyCode === 9) {
      if (moveFns) {
        e.preventDefault()
        moveFns.right()
      }
    } else if (keyCode === 40) {
      if (moveFns) {
        e.preventDefault()
        moveFns.down()
      }
    } else if (keyCode === 38) {
      if (moveFns) {
        e.preventDefault()
        moveFns.up()
      }
    } else if (keyCode === 86 && !ctrlKey && !metaKey) {
      e.preventDefault()
    } else if (keyCode === 67 && !ctrlKey && !metaKey) {
      e.preventDefault()
    }
  }
  onClick = () => {
    const { year, category, changeCell } = this.props
    if (changeCell) {
      changeCell(year, category)
    }
  }
  onWheel = e => {
    if (e.target === document.activeElement) {
      e.preventDefault()
      e.target.blur()
    }
  }
  onPaste = e => {
    const text = e.clipboardData.getData('text')
    const num = parseInt(text, 10)
    if (text.includes('.') || Number.isNaN(num) || !Number.isInteger(num)) {
      e.preventDefault()
      return false
    }
  }
  onChange = e => {
    const { onChange } = this.props
    if (onChange) {
      e.persist()
      onChange(e)
    }
  }
  getDefaultValue = data => {
    if (typeof data === 'number' && !Number.isNaN(data)) {
      return Math.round(data)
    } else {
      return ''
    }
  }
  unannualize = val => {
    const { annualizationCoefficient } = this.props
    return Math.round(val / annualizationCoefficient)
  }
  render() {
    const {
      isEditable,
      cellRef,
      discrepancy,
      period,
      days,
      entity,
      resourceType,
      year,
      isItalic,
      category,
      source,
      yearPeriod,
      isTableEditable,
      categoryInfo,
      id,
      annualizationCoefficient
    } = this.props
    const { data } = this.state
    if (isEditable !== true) {
      // This should be a function
      let renderedData
      if (typeof data === 'number' && !Number.isNaN(data)) {
        if (period === 'interim' && source !== 'derived' && yearPeriod === 'tax') {
          renderedData = ''
        }
        if (period !== 'interim' || period === 'interim' && resourceType === 'Guarantor' || days >= 365 || source === 'derived') {
          renderedData = formatNumber(Math.round(data))
        } else if (period === 'interim' && resourceType === 'Business' && entity.financial && annualizationCoefficient && days < 365) {
          // Partial interim year - data should be annualized
          renderedData = formatNumber(Math.round(data * annualizationCoefficient))
        }
      } else if (typeof data === 'string') {
        renderedData = Math.round(data)
      } else {
        renderedData = ''
      }
      if (source === 'derived' &&
          period === 'interim' &&
          resourceType === 'Business' &&
          isTableEditable &&
          typeof data === 'number' &&
          !Number.isNaN(data)
      ) {
        renderedData = formatNumber(this.unannualize(data))
      }
      if (categoryInfo && !categoryInfo.required && period === 'interim' && resourceType === 'Business' && isTableEditable && typeof data === 'number' && !Number.isNaN(data)) {
        // If category is an additional category and the table is editable, render data as-is
        renderedData = formatNumber(data)
      }
      if (category in minusOnes && renderedData !== null && renderedData !== '') {
        // Negative data should be enclosed in parentheses
        renderedData = '(' + renderedData + ')'
      }
      if (isEditable !== true) {
        return (
          <Span bold={isItalic} italic={isItalic} id={id}>
            {renderedData}
            {discrepancy && <Exclamation className="fa fa-exclamation-circle" />}
          </Span>
        )
      }
    } else {
      return (
        <Input
          onBlur={this.onBlur}
          type="text"
          defaultValue={this.getDefaultValue(data)}
          onChange={this.onChange}
          //eslint-disable-next-line
          innerRef={node => { this.input = node; cellRef && cellRef(node, `${year}${category}`) }} //call ref function from <Pane />
          onKeyDown={this.onKeyDown}
          onClick={this.onClick}
          onWheel={this.onWheel}
          min="0"
          onPaste={this.onPaste}
          style={this.state.error ? { color: 'red' } : {}}
          id={id}
        />
      )
    }
  }
}

Cell.propTypes = {
  category: PropTypes.string,
  client: PropTypes.shape({
    readQuery: PropTypes.func.isRequired,
    writeQuery: PropTypes.func.isRequired
  }),
  data: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  entityId: PropTypes.number,
  isEditable: PropTypes.bool,
  loanId: PropTypes.number,
  period: PropTypes.string,
  refetch: PropTypes.func,
  resourceType: PropTypes.string,
  year: PropTypes.number
}

export default withApollo(Cell)
